export default __webpack_public_path__ + "static/media/warehouse.954c2133.svg";